import { createSlice } from "@reduxjs/toolkit";
import { initialAsync } from "./operations";
import { OptinState } from "./state";

const initialState: OptinState = {
  hasError: false,
};

export const optinSlice = createSlice({
  name: "optin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(initialAsync.pending, (state) => {
      state.hasError = false;
    });
    builder.addCase(initialAsync.fulfilled, (state) => {
      state.hasError = false;
    });
    builder.addCase(initialAsync.rejected, (state) => {
      state.hasError = true;
    });
  },
});

export default optinSlice.reducer;
